
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mobiworkx/e-gift-card-rewards",
      function () {
        return require("private-next-pages/mobiworkx/e-gift-card-rewards.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mobiworkx/e-gift-card-rewards"])
      });
    }
  